
import { defineComponent } from "vue";
import "@/assets/scss/patient/dashboard.scss";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "dashboard",
});
